<div class="container-fluid">
    <app-pagetitle title="Account Settings" [subtitle]="'Manage your profile and preferences'"></app-pagetitle>

    <div class="page-content-wrapper">
        <div [class.loading-content]="loading">
            <app-loader [loading]="loading"></app-loader>

            <div class="card border-0 shadow-sm mb-4">
                <div class="card-body p-4">
                    <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
                        <div>
                            <div class="d-flex align-items-center gap-2 mb-2">
                                <div
                                    class="avatar-sm rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center">
                                    <i class="mdi mdi-account-cog"></i>
                                </div>
                                <h4 class="fw-bold mb-0">Personalize your account</h4>
                            </div>
                        </div>
                        <!-- <div class="d-flex gap-2 flex-wrap">
                            <span class="badge bg-success-subtle text-success">Secure</span>
                            <span class="badge bg-primary-subtle text-primary">Managed</span>
                        </div> -->
                    </div>

                    <ul class="nav nav-pills mt-4" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link fw-semibold" [class.active]="activeTab === 'esign'"
                                (click)="switchTab('esign')" type="button" role="tab"
                                [attr.aria-selected]="activeTab === 'esign'">
                                E-Sign Profile
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link fw-semibold" [class.active]="activeTab === 'estamp'"
                                (click)="switchTab('estamp')" type="button" role="tab"
                                [attr.aria-selected]="activeTab === 'estamp'">
                                E-Stamp Profile
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            @if(activeTab === 'estamp'){
            <div class="row">
                <div class="col-12">
                    <div class="card border-0 shadow-sm h-100">
                        <div
                            class="card-header bg-transparent border-0 d-flex justify-content-between align-items-center px-4 pt-4">
                            <div>
                                <h5 class="fw-bold mb-1">
                                    <i class="mdi mdi-stamp text-primary me-2"></i>E-Stamp Profile Information
                                </h5>
                                <p class="text-muted small mb-0">Your e-stamp service status and account details</p>
                            </div>
                            <span class="badge"
                                [ngClass]="customerEstampProfile?.estampService === 'ACTIVE' ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'">
                                {{ customerEstampProfile?.estampService }}
                            </span>
                        </div>
                        <div class="card-body p-4">
                            <div class="row g-4">
                                <div class="col-md-6">
                                    <div class="p-3 rounded-3 bg-light h-100">
                                        <div class="fw-semibold text-muted mb-2">Basic Info</div>
                                        <div class="mb-3">
                                            <small class="text-muted d-block">Name</small>
                                            <div class="fw-semibold">{{ customerEstampProfile?.name || '-' }}</div>
                                        </div>
                                        <div class="mb-3">
                                            <small class="text-muted d-block">Email</small>
                                            <div class="fw-semibold">{{ customerEstampProfile?.email || '-' }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="p-3 rounded-3 bg-light h-100">
                                        <div class="fw-semibold text-muted mb-2">Company & Contact</div>
                                        <div class="mb-3">
                                            <small class="text-muted d-block">Company</small>
                                            <div class="fw-semibold">{{ customerEstampProfile?.company || '-' }}</div>
                                        </div>
                                        <div class="mb-3">
                                            <small class="text-muted d-block">Phone</small>
                                            <div class="fw-semibold">{{ customerEstampProfile?.phone || '-' }}</div>
                                        </div>
                                        @if(customerEstampProfile?.estampService == 'ACTIVE'){
                                        <div>
                                            <small class="text-muted d-block">Assigned Maker</small>
                                            <div class="fw-semibold">{{ customerEstampProfile?.userName || '-' }}</div>
                                        </div>
                                        }
                                    </div>
                                </div>
                                @if(customerEstampProfile?.estampService !== 'ACTIVE'){
                                <div class="col-12">
                                    <div
                                        class="d-flex flex-column flex-md-row justify-content-between align-items-md-center border rounded-3 p-3 bg-primary-subtle">
                                        <div>
                                            <div class="fw-semibold">E-Stamp Service</div>
                                            <small class="text-muted d-block">
                                                {{ (customerEstampProfile?.estampService === 'PENDING' ||
                                                customerEstampProfile?.estampService === 'REQUESTED') ? 'Activation
                                                request is pending approval.' : 'Service is currently inactive.' }}
                                            </small>
                                        </div>
                                        @if(customerEstampProfile?.estampService !== 'PENDING' &&
                                        customerEstampProfile?.estampService !== 'REQUESTED'){
                                        <button type="button" class="btn btn-primary mt-3 mt-md-0" [disabled]="loading"
                                            (click)="confirmToggleEstamp()">
                                            Activate
                                        </button>
                                        }
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            } @else{
            <div class="row g-4">
                <div class="col-lg-6">
                    <div class="card border-0 shadow-sm h-100">
                        <div class="card-header bg-transparent border-0 px-4 pt-4">
                            <h5 class="fw-bold mb-1">
                                <i class="mdi mdi-account-edit text-primary me-2"></i>Profile Information
                            </h5>
                            <p class="text-muted small mb-0">Keep your business details up to date</p>
                        </div>
                        <form [formGroup]="profileForm" (ngSubmit)="updateProfile()">
                            <div class="card-body p-4">
                                <div class="row g-3">
                                    <div class="col-12">
                                        <label class="form-label fw-semibold">Company Name</label>
                                        <input type="text" class="form-control rounded-3" placeholder="Company Name"
                                            formControlName="company"
                                            [ngClass]="{ 'is-invalid': profileSubmitted && profileControls.company.errors }">
                                        @if(profileSubmitted && profileControls.company.errors){
                                        <div class="invalid-feedback">
                                            @if(profileControls.company.errors.required){
                                            <div>Company name is required</div>
                                            }
                                        </div>
                                        }
                                    </div>
                                    <div class="col-12">
                                        <label class="form-label fw-semibold">Email</label>
                                        <input type="email" class="form-control rounded-3" placeholder="Email"
                                            formControlName="email"
                                            [ngClass]="{ 'is-invalid': profileSubmitted && profileControls.email.errors }">
                                        @if(profileSubmitted && profileControls.email.errors){
                                        <div class="invalid-feedback">
                                            @if(profileControls.email.errors.required){
                                            <div>Email is required</div>
                                            }
                                            @if(profileControls.email.errors.email){
                                            <div>Email must be a valid email address</div>
                                            }
                                        </div>
                                        }
                                    </div>
                                    <div class="col-12">
                                        <label class="form-label fw-semibold">Phone</label>
                                        <input type="text" class="form-control rounded-3" placeholder="Phone"
                                            formControlName="phone"
                                            [ngClass]="{ 'is-invalid': profileSubmitted && profileControls.phone.errors }">
                                        @if(profileSubmitted && profileControls.phone.errors){
                                        <div class="invalid-feedback">
                                            @if(profileControls.phone.errors.required){
                                            <div>Phone is required</div>
                                            }
                                            @if(profileControls.phone.errors.pattern){
                                            <div>Phone must start with 6–9 and contain 10 digits</div>
                                            }
                                        </div>
                                        }
                                    </div>
                                </div>
                                <button class="btn btn-primary mt-4" type="submit">Save Changes</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="card border-0 shadow-sm h-100">
                        <div class="card-header bg-transparent border-0 px-4 pt-4">
                            <h5 class="fw-bold mb-1">
                                <i class="mdi mdi-shield-lock text-primary me-2"></i>Security
                            </h5>
                            <p class="text-muted small mb-0">Protect your account with a strong password</p>
                        </div>

                        <form [formGroup]="securityForm" (ngSubmit)="updateSecurity()">
                            <div class="card-body p-4">
                                <div class="row g-3">
                                    <div class="col-12 auth-custom">
                                        <label class="form-label fw-semibold">Current Password</label>
                                        <input [type]="confirmPassword ? 'text' : 'password'"
                                            class="form-control rounded-3" placeholder="Current Password"
                                            formControlName="oldPassword"
                                            [ngClass]="{ 'is-invalid': securitySubmitted && securityControls.oldPassword.errors }">
                                        <i class="password-eye" [class.ri-eye-line]="confirmPassword"
                                            [class.ri-eye-off-line]="!confirmPassword"
                                            (click)="togglePassword('confirmPassword')"></i>
                                        @if(securitySubmitted && securityControls.oldPassword.errors){
                                        <div class="invalid-feedback">
                                            @if(securityControls.oldPassword.errors.required){
                                            <div class="text-danger">Current Password is required</div>
                                            }
                                        </div>
                                        }
                                    </div>
                                    <div class="col-12 auth-custom">
                                        <label class="form-label fw-semibold">New Password</label>
                                        <input [type]="showPassword ? 'text' : 'password'"
                                            class="form-control rounded-3" placeholder="New Password"
                                            formControlName="newPassword"
                                            [ngClass]="{ 'is-invalid': securitySubmitted && securityControls.newPassword.errors }">
                                        <i class="password-eye" [class.ri-eye-line]="showPassword"
                                            [class.ri-eye-off-line]="!showPassword"
                                            (click)="togglePassword('showPassword')"></i>
                                        @if(securitySubmitted && securityControls.newPassword.errors){
                                        <div class="invalid-feedback">
                                            @if(securityControls.newPassword.errors.required){
                                            <div class="text-danger">New Password is required</div>
                                            }
                                            @if(securityControls.newPassword.errors.minlength){
                                            <div class="text-danger">Password must be at least 8 characters</div>
                                            }
                                            @if(securityControls.newPassword.errors.pattern){
                                            <div class="text-danger">Password must include uppercase, lowercase, number
                                                & special character</div>
                                            }
                                        </div>
                                        }
                                    </div>
                                    <div class="col-12 auth-custom">
                                        <label class="form-label fw-semibold">Confirm New Password</label>
                                        <input [type]="showConfirmPassword ? 'text' : 'password'"
                                            class="form-control rounded-3" placeholder="Confirm New Password"
                                            formControlName="confirmPassword" (paste)="$event.preventDefault()"
                                            [ngClass]="{ 'is-invalid': securitySubmitted && securityControls.confirmPassword.errors }">
                                        <i class="password-eye" [class.ri-eye-line]="showConfirmPassword"
                                            [class.ri-eye-off-line]="!showConfirmPassword"
                                            (click)="togglePassword('showConfirmPassword')"></i>
                                        @if(securityControls.confirmPassword.errors?.mismatch){
                                        <div class="text-danger">Passwords do not match</div>
                                        }
                                    </div>
                                </div>
                                <button class="btn btn-primary mt-4" type="submit">Update Password</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="row g-4 mt-1">
                <div class="col-lg-6">
                    <div class="card border-0 shadow-sm h-100">
                        <div class="card-header bg-transparent border-0 px-4 pt-4">
                            <h5 class="fw-bold mb-1">
                                <i class="mdi mdi-bell-ring text-primary me-2"></i>Notification Preferences
                            </h5>
                            <p class="text-muted small mb-0">Choose how you receive updates</p>
                        </div>

                        <div class="card-body p-4" [formGroup]="notificationForm">
                            <div class="form-check form-switch mb-3">
                                <input class="form-check-input" type="checkbox" formControlName="email" id="email" />
                                <label class="form-check-label" for="email">Email notifications for document status
                                    changes</label>
                            </div>
                            <div class="form-check form-switch mb-3">
                                <input class="form-check-input" type="checkbox" formControlName="sms" id="sms" />
                                <label class="form-check-label" for="sms">SMS notifications for signatures</label>
                            </div>
                            <div class="form-check form-switch mb-3">
                                <input class="form-check-input" type="checkbox" formControlName="whatsApp"
                                    id="whatsApp" />
                                <label class="form-check-label" for="whatsApp">WhatsApp notifications</label>
                            </div>
                            <div class="form-check form-switch mb-3">
                                <input class="form-check-input" type="checkbox" formControlName="weeklyUsageReports"
                                    id="weeklyUsageReports" />
                                <label class="form-check-label" for="weeklyUsageReports">Weekly usage reports</label>
                            </div>
                            <button class="btn btn-primary mt-2" (click)="updateNotificationPreference()">Save
                                Preferences</button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="card border-0 shadow-sm h-100">
                        <div class="card-header bg-transparent border-0 px-4 pt-4">
                            <h5 class="fw-bold mb-1">
                                <i class="mdi mdi-brush text-primary me-2"></i>White-Label Branding
                            </h5>
                            <p class="text-muted small mb-0">Personalize your company brand</p>
                        </div>

                        <div class="card-body p-4">
                            <form [formGroup]="brandingForm" (ngSubmit)="saveBranding()">
                                <div class="row g-4">
                                    <div class="col-12">
                                        <label class="form-label fw-semibold">Company Logo</label>
                                        <input type="file" class="form-control rounded-3" accept="image/png, image/jpeg"
                                            #fileInput (change)="onFileSelect($event)" />
                                        <small class="text-muted d-block mt-1">Allowed formats: JPG, PNG. Max size:
                                            500KB.</small>
                                        <div class="text-danger mt-1" *ngIf="fileError">{{ fileError }}</div>

                                        <div class="modal fade show d-block" *ngIf="showCropper" tabindex="-1">
                                            <div class="modal-dialog modal-dialog-centered cropper-modal">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title">Crop Company Logo</h5>
                                                        <button type="button" class="btn-close"
                                                            (click)="closeCropper()"></button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <image-cropper [imageChangedEvent]="imageChangedEvent"
                                                            [maintainAspectRatio]="true" [aspectRatio]="2 / 1"
                                                            [resizeToWidth]="100" [resizeToHeight]="50" format="png"
                                                            (imageCropped)="imageCropped($event)">
                                                        </image-cropper>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button class="btn btn-secondary"
                                                            (click)="closeCropper()">Cancel</button>
                                                        <button class="btn btn-primary" (click)="confirmCrop()">Crop &
                                                            Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="previewImage && !showCropper" class="mt-3">
                                            <small class="fw-semibold text-secondary me-3">Preview</small>
                                            <div class="logo-preview mt-2">
                                                <img [src]="previewImage" width="100" height="50"
                                                    class="border rounded" />
                                                <button type="button" class="btn btn-sm btn-danger logo-remove-btn"
                                                    (click)="removeLogo()">×</button>
                                            </div>
                                        </div>

                                        <div *ngIf="logo && !previewImage" class="mt-3">
                                            <small class="fw-semibold text-secondary me-3">Current Logo</small>
                                            <div class="logo-preview mt-2">
                                                <img [src]="logo" class="img-fluid border rounded" width="100"
                                                    height="50" style="max-height: 80px" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <label class="form-label">Primary Color</label>
                                        <input type="color" class="form-control form-control-color w-100"
                                            formControlName="primaryColor" />
                                    </div>

                                    <div class="col-md-6">
                                        <label class="form-label">Secondary Color</label>
                                        <input type="color" class="form-control form-control-color w-100"
                                            formControlName="secondaryColor" />
                                    </div>
                                </div>

                                <button type="submit" class="btn btn-primary mt-4"
                                    [disabled]="brandingForm.invalid || fileError">
                                    Save Branding
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</div>
